export const phases = [
  "Founders & Shares",
  "Time Commitment",
  " Roles & Responsibilities",
  "Leaver Events",
  "Call Options",
  "Example",
];
